import { useEffect, useState } from "react";
import { ShieldAlert, FileBadge2, ExternalLink, Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Vinci Inc. company certificate register — admin-only, internal compliance.
export function CompanyCertificatesRegister({ api }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/company/certificates").then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || "Could not load register"));
  }, [api]);
  return (
    <div className="admin-card" data-testid="company-certificates-register">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-sm uppercase tracking-wider text-[#C9A84C] inline-flex items-center gap-2"><Lock size={14} /> Internal compliance only</div>
          <h3 className="font-serif text-2xl text-[#F5F5F5] mt-1">Company certificate register</h3>
          <p className="text-sm text-[#888888] mt-1 max-w-2xl">Vinci Inc.'s own registrations. Admin-gated at the application layer — never rendered on partner, buyer, seller or custodian surfaces.</p>
        </div>
        {data?.retired?.length > 0 && (
          <div className="text-sm text-[#888888] inline-flex items-center gap-2 border border-[#333333] rounded-lg px-3 py-2" data-testid="company-certificates-retired">
            <ShieldAlert size={14} className="text-[#C0392B]" /> Retired &amp; purged: {data.retired.join(", ")}
          </div>
        )}
      </div>
      {err && <div className="mt-4 text-sm text-[#C0392B]">{err}</div>}
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {(data?.certificates || []).map((c) => (
          <div key={c.id} data-testid={`company-cert-${c.kind}`} className="rounded-lg border border-[#262626] bg-[#0D0D0D] p-5">
            <div className="flex items-center gap-3">
              <span className="grid place-items-center w-10 h-10 rounded-lg bg-[#C9A84C]/10 border border-[#C9A84C]/30"><FileBadge2 size={18} className="text-[#C9A84C]" /></span>
              <div>
                <div className="text-base font-bold text-[#F5F5F5]">{c.title}</div>
                <div className="text-sm text-[#888888]">{c.issuer}</div>
              </div>
            </div>
            <dl className="mt-4 grid grid-cols-[140px_1fr] gap-y-2 text-sm">
              <dt className="text-[#888888]">Number</dt><dd className="font-mono text-[#F5F5F5]" data-testid={`company-cert-${c.kind}-number`}>{c.number}</dd>
              <dt className="text-[#888888]">File no.</dt><dd className="font-mono text-[#F5F5F5]">{c.file_number}</dd>
              <dt className="text-[#888888]">Issued on</dt><dd className="text-[#F5F5F5]">{c.issued_on}</dd>
              <dt className="text-[#888888]">Entity</dt><dd className="text-[#F5F5F5]">{c.entity} · {c.nature}</dd>
              <dt className="text-[#888888]">Signatory</dt><dd className="text-[#F5F5F5]">{c.signatory}</dd>
              <dt className="text-[#888888]">Address</dt><dd className="text-[#D4D4D4]">{c.address}</dd>
            </dl>
            <div className="mt-5 flex flex-wrap gap-3">
              <a data-testid={`company-cert-${c.kind}-open`} href={`${API}/admin/company/certificates/${c.id}/file`} target="_blank" rel="noreferrer"
                 className="inline-flex items-center gap-2 rounded-lg bg-[#C9A84C] text-black px-4 py-2 text-sm font-semibold hover:bg-[#D8B75B] transition-colors">
                <FileBadge2 size={14} /> Open certificate PDF
              </a>
              {c.verify_url && <a href={c.verify_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-lg border border-[#333333] px-4 py-2 text-sm text-[#D4D4D4] hover:border-[#C9A84C] transition-colors"><ExternalLink size={14} /> Verify at DGFT</a>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
